import React, { useState, useEffect, useRef } from "react";


import imgField from "/src/assets/field.svg"


function FieldBlock({ formationInfo, teamSheetPlayers, allTeamPlayers, color }) {

    const topGap = 15;
    const numOfRows = 6.1;
    const columnGap = 10;
    const rowHeight = (100 - topGap) / numOfRows;

    const positions = formationInfo?.positions || [];


    const fieldRef = useRef(null);
    const [fieldWidth, setFieldWidth] = useState(0);
    const [display, setDisplay] = useState('none');

    useEffect(() => {

        const element = fieldRef.current;

        const updateWidth = () => {
            if (element) {
                setFieldWidth(element.offsetWidth);
                setDisplay('block');
            }
        };

        // Получаем начальную ширину элемента
        updateWidth();

        // Создаём наблюдателя за размерами
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(element);

        // Очистка при размонтировании
        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    if (!positions.length || !teamSheetPlayers || !allTeamPlayers) {
        console.warn("[FieldBlock] Missing required data (positions, teamSheetPlayers, or allTeamPlayers)");
        return <div style={{textAlign: 'center', padding: '20px'}}>Loading lineup...</div>;
    }

    // Create a mutable copy so we can "consume" players as we assign them to slots.
    const availableSheetPlayers = [...teamSheetPlayers];

    const players = positions.map(function (position, index) {

        const effectiveCols = position.cols === "5" ? 5 : 4;
        const playerWidth = fieldWidth > 0 ? Math.max(70, (fieldWidth - columnGap * (effectiveCols + 1)) / effectiveCols) : 70; // ensure minimum width 70px
        const columnWidth = 100 / position.cols;
        const leftPos = columnWidth * position.col - columnWidth / 2;
        const topPos = topGap + rowHeight * (position.row - 1);
        const itemMargin = `0 0 0 -${playerWidth / 2}px`;

        const fontSize = Math.max(playerWidth / 3, 8);

        // --- UNIQUE PLAYER-SLOT MAPPING ---
        // Find the FIRST unused sheet player whose position matches this slot
        const matchingIndex = availableSheetPlayers.findIndex(p => p.position === position.position);

        let playerInfo = null;
        if (matchingIndex !== -1) {
            // Remove it from the pool so it won't be reused for another identical slot
            const sheetPlayer = availableSheetPlayers.splice(matchingIndex, 1)[0];
            const playerWyId = sheetPlayer?.wyId;
            if (playerWyId != null) {
                playerInfo = allTeamPlayers.find(p => String(p.wyId) === String(playerWyId));
            }
        }

        const styles = {
            left: leftPos + '%',
            width: playerWidth > 0 ? `${playerWidth}px` : '60px',
            top: topPos + '%',
            margin: itemMargin,
            display: display
        };

        const stylesIcon = {
            fontSize: `${fontSize}px`,
            color: color || '#0040FF'
        };

        return (
            <div key={position.id || `pos-${index}`} className={"player-place-item"}
                 style={styles}
            >
                <div className="icon">
                    <span style={stylesIcon} className="player-ico icon-t-shirt" />
                </div>
                <div className="descr-block">
                    <div className="name">{playerInfo?.name || ''}</div>
                </div>

            </div>
        );
    });

    return (
        <div className="field-container">
            <img src={imgField} alt="field"/>


            <div ref={fieldRef} className="players-places">
                {players}
            </div>

        </div>

  )
}

export {FieldBlock}
